(function() {
    'use strict';

    angular
        .module('elogbooks')
        .config(Translations);

    function Translations($translateProvider) {
        $translateProvider.translations('en-gb', {
            CONTACT_US_LIST: 'Contact Us',
            HD_SUPPORT_NUMBER: 'Helpdesk Support Number',
            SERVICE_DESK_NUMBER: 'Service Desk Number',
            CAFM_EMAIL: 'CAFM Support Email Address'
        });
    }
})();
